import { apiClient } from './axios';

import type {
  ToolsResponse,
  CustomToolDetail,
  CreateCustomToolDto,
  UpdateCustomToolDto,
  CustomToolQuery,
  PaginatedResponse,
  TestCustomToolDto,
  TestCustomToolResponse,
} from '@repo/shared-types';

export interface GeminiModelInfo {
  id: string;
  displayName: string;
}

export const toolsApi = {
  getTools: async (): Promise<ToolsResponse> => {
    const response = await apiClient.get<ToolsResponse>('/tools');
    return response.data;
  },

  getGeminiModels: async (): Promise<GeminiModelInfo[]> => {
    const response = await apiClient.get<GeminiModelInfo[]>('/tools/gemini-models');
    return response.data;
  },

  // Custom tools
  getCustomTools: async (query?: CustomToolQuery) => {
    const response = await apiClient.get<PaginatedResponse<CustomToolDetail>>('/custom-tools', {
      params: query,
    });
    return response.data;
  },

  getCustomTool: async (id: string) => {
    const response = await apiClient.get<CustomToolDetail>(`/custom-tools/${id}`);
    return response.data;
  },

  createCustomTool: async (data: CreateCustomToolDto) => {
    const response = await apiClient.post<CustomToolDetail>('/custom-tools', data);
    return response.data;
  },

  updateCustomTool: async (id: string, data: UpdateCustomToolDto) => {
    const response = await apiClient.patch<CustomToolDetail>(`/custom-tools/${id}`, data);
    return response.data;
  },

  getCustomToolUsage: async (id: string) => {
    const response = await apiClient.get<{
      toolId: string;
      isUsed: boolean;
      configurations: Array<{ id: string; name: string }>;
    }>(`/custom-tools/${id}/usage`);
    return response.data;
  },

  deleteCustomTool: async (id: string, force = false) => {
    await apiClient.delete(`/custom-tools/${id}`, {
      params: { force: force ? 'true' : 'false' },
    });
  },

  testCustomTool: async (data: TestCustomToolDto): Promise<TestCustomToolResponse> => {
    const response = await apiClient.post<TestCustomToolResponse>('/custom-tools/test', data);
    return response.data;
  },
};
